import isFinite from 'lodash/isFinite';

/**
 * Track onboarded conversion.
 */
export const trackOnboardedForImpact = (userID: string): void => {
  const trackID = isFinite(parseInt(process.env.NEXT_PUBLIC_IMPACT_TRACK_ID || '', 10));
  if (window.ire && trackID) {
    window.ire(
      'trackConversion',
      21422,
      {
        orderId: userID,
        customerId: userID,
        customerEmail: '',
        customerStatus: 'New',
        orderPromoCode: '',
      },
      {
        verifySiteDefinitionMatch: true,
      }
    );
  }
};
